var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"overlay"}},[_c('div',{staticClass:"d-flex align-items-center dialog_height"},[_c('div',{staticClass:"mypage-friend-input mypage-visit-input"},[_c('div',{staticClass:"p-2 pb-3"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }